import { render, staticRenderFns } from "./ItemDrop.vue?vue&type=template&id=11dd32e6&scoped=true&"
import script from "./ItemDrop.vue?vue&type=script&lang=js&"
export * from "./ItemDrop.vue?vue&type=script&lang=js&"
import style0 from "./ItemDrop.vue?vue&type=style&index=0&id=11dd32e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11dd32e6",
  null
  
)

export default component.exports